import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";

function FieldsDisplay({ title, style, fields, showTitle }) {
	const theme = useTheme();
	showTitle = showTitle || theme?.customOptions?.fieldsDisplayTitle === true;
	const cardStyle = style
		? style
		: theme?.customOptions?.fieldsDisplayStyle || "framed";

	const Wrap = ({ children }) => {
		if (cardStyle === "no_border") {
			return <Box className="fields-display transparent">{children}</Box>;
		} else {
			return (
				<Paper
					sx={(theme) => ({
						padding: theme.spacing(3),
						backgroundColor: theme.palette.grey["200"],
					})}
					className="fields-display"
				>
					{children}
				</Paper>
			);
		}
	};

	return (
		<Wrap>
			{showTitle && title && <Typography variant="h3">{title}</Typography>}
			<Box
				sx={(theme) => ({
					"& table": {
						width: "100%",
						borderCollapse: "collapse",

						"& th, & td": {
							borderBottom: `1px solid ${theme.palette.grey["400"]}`,
							paddingTop: theme.spacing(2),
							paddingBottom: theme.spacing(2),
						},
						"& tr:last-child": {
							"& th, & td": {
								borderBottom: "none",
							},
						},
						"& th": {
							textAlign: "left",
							verticalAlign: "top",
							width: "30%",
							paddingRight: theme.spacing(2),
							paddingBottom: theme.spacing(2),
						},
						"& td": {
							textAlign: "left",
							verticalAlign: "top",
							width: "70%",

							"& a": {
								color: theme.palette.link.main,
							},
							"& ul": {
								listStyle: "none",
								padding: 0,
								margin: 0,
								"& li": {
									"&:not(:last-child)": {
										marginBottom: theme.spacing(1),
									},
									"& strong": {
										display: "inline-block",
										paddingRight: theme.spacing(1),
									},
								},
								" & + ul": {
									paddingTop: theme.spacing(2),
									marginTop: theme.spacing(2),
									borderTop: `1px solid ${theme.palette.grey["400"]}`,
								},
							},
						},
					},
				})}
			>
				<table>
					{fields
						.filter((f) => !!f.value)
						.map((f) => (
							<tr>
								<th>
									{f.label && `${f.label}`.length > 0 ? <>{f.label}: </> : ""}
								</th>
								<td>
									{Array.isArray(f.value) ? (
										<Box className="sub-values">
											{f.value.map((group) => (
												<Box component="ul">
													{group.map((v) => (
														<Box component="li">
															{v.label && `${v.label}`.length > 0 ? (
																<strong>{v.label}: </strong>
															) : (
																""
															)}
															<span
																dangerouslySetInnerHTML={{ __html: v.value }}
															/>
														</Box>
													))}
												</Box>
											))}
										</Box>
									) : (
										<span dangerouslySetInnerHTML={{ __html: f.value }} />
									)}
								</td>
							</tr>
						))}
				</table>
			</Box>
		</Wrap>
	);
}

export default FieldsDisplay;
